<template>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
</template>

<script>
    export default {
        name: 'icon-filter-arrow-down'
    }
</script>